<template>
	<div v-if="isVisible">
		<div class="report_row rehab_table report_common_table page">
			<div class="sub_header">
				{{ $t( 'report.paper.rehabilitation.info' ) }}
			</div>
			<RehabilitationTable :rehabilitationItemsProps="rehabilitationItemsProps"/>
			<span class="caution">
				{{ $t( 'report.paper.rehabilitation.caution_info' ) }}
			</span>
		</div>
		<div class="report_row page">
			<div class="sub_header">
				{{ $t( 'report.paper.rehabilitation.rom_graph' ) }}
				<span>
					({{ searchDateProps }})
				</span>
			</div>
			<RomGraphSection class="rom_graph_for_browser" :romChartDataProps="romChartDataProps" :isViewOnlyProps="true"/>
			<img
          class="rom_graph_for_print"
          :src="romGraphImage.src"
          :style="`max-height : 390px;`"
          :height="romGraphImage.height"
          alt=""
      >
		</div>
		<RomChangeTable :searchDateProps="searchDateProps"/>
	</div>
</template>

<script>
import RehabilitationTable from './rehabilitationTable'
import RomGraphSection from '@/components/body/myPatient/report/reportItem/romChangeMonitoringGraph/romGraphSection'
import RomChangeTable from './romChangeTable'
import { mapGetters } from 'vuex'

export default {
  name: 'RomChangeSection',
  props: ['rehabilitationItemsProps', 'searchDateProps', 'romChartDataProps'],
  components: {RehabilitationTable, RomGraphSection, RomChangeTable},
  data() {
    return {
      romGraphImage: {
        src: '',
        width: 0,
        height: 0
      },
      isVisible: false
    }
  },
  methods: {
    ...mapGetters(['getReport']),
    updateRomGraphImage(params) {
      this.romGraphImage.src = params?.src ?? ''
      this.romGraphImage.width = params?.width ?? 0
      this.romGraphImage.height = params?.height ?? 0
    }
  },
  mounted() {
    this.updateRomGraphImage(this.getReport().romChartImage);
  },
  created() {
    this.unsubscribe = this.$store.subscribe((_mutation, state) => {
      this.updateRomGraphImage(state.report.romChartImage);
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  watch: {
    rehabilitationItemsProps: {
      deep: true,
      handler() {
        this.isVisible = this.rehabilitationItemsProps.isSuccess
      }
    }
  }
}
</script>
<style lang="scss">
.caution {
  color: red;
  line-height: 1.5rem;
	font-size: 10px;
}
</style>